import { __module as lib } from '../../../../_virtual/index70.js';
import React__default from 'react';
import { __require as requireImplementation } from './implementation.js';

var hasRequiredLib;

function requireLib () {
	if (hasRequiredLib) return lib.exports;
	hasRequiredLib = 1;
	(function (module, exports) {

		exports.__esModule = true;

		var _react = React__default;

		var _react2 = _interopRequireDefault(_react);

		var _implementation = requireImplementation();

		var _implementation2 = _interopRequireDefault(_implementation);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		exports.default = _react2.default.createContext || _implementation2.default;
		module.exports = exports['default']; 
	} (lib, lib.exports));
	return lib.exports;
}

export { requireLib as __require };
